import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Pill — status badge. Dot is colored, label stays --ink-secondary.
 *
 * Per DESIGN-SYSTEM.md §5: "Never the entire pill colored — only the dot."
 * 11px UPPERCASE label, dot 6 px circle. */
import { forwardRef } from 'react';
const dotByTone = {
    ok: 'var(--signal-ok)',
    watch: 'var(--signal-watch)',
    warn: 'var(--signal-warn)',
    alarm: 'var(--signal-alarm)',
    coral: 'var(--accent)',
    neutral: 'var(--ink-quaternary)',
};
const sizeDim = {
    sm: { h: '20px', px: '10px', fs: '10px' },
    md: { h: '22px', px: '10px', fs: '11px' },
};
export const Pill = forwardRef(function Pill({ tone = 'neutral', label, size = 'md', style, ...rest }, ref) {
    const d = sizeDim[size];
    const merged = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        height: d.h,
        paddingLeft: d.px,
        paddingRight: d.px,
        borderRadius: 'var(--radius-pill)',
        border: '1px solid var(--border-hairline)',
        background: 'var(--bg-surface)',
        color: 'var(--ink-secondary)',
        fontSize: d.fs,
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        fontFamily: "'Geist', 'Inter Tight', -apple-system, BlinkMacSystemFont, sans-serif",
        ...style,
    };
    const dotStyle = {
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        background: dotByTone[tone],
        flexShrink: 0,
    };
    return (_jsxs("span", { ref: ref, style: merged, ...rest, children: [_jsx("span", { "aria-hidden": true, style: dotStyle }), label] }));
});
//# sourceMappingURL=Pill.js.map